import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'

import { NavController } from '@ionic/angular'

import { Observable } from 'rxjs'
import { delay, map, take } from 'rxjs/operators'

import { RouteUrl } from '@core/enums/routing.enums'
import { trimUrl } from '../../utils/main.utils'
import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { Store } from '@ngrx/store'
import { isPagePermitted } from '@core/store/selectors/auth.selector'
import { authenticatedSuccess, signIn } from '@core/store/actions/auth.actions'
import { STORAGE_LAST_URL_KEY } from '@core/auth/constants/auth.constants'
import { DebounceTimeType } from '@core/enums/application.enums'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private readonly _ionicAuth: CoreAuthService = inject(CoreAuthService)
  private readonly _navCtrl: NavController = inject(NavController)
  private readonly _store: Store = inject(Store)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._ionicAuth.isAuthenticated$.pipe(
      delay(DebounceTimeType.Long),
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          sessionStorage.setItem(STORAGE_LAST_URL_KEY, state.url)
          this._store.dispatch(signIn())
        } else {
          this._store.dispatch(authenticatedSuccess())
        }
        return isAuthenticated
      }),
      take(1)
    )
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._store.pipe(isPagePermitted(state.url)).pipe(
      delay(DebounceTimeType.Long),
      map((isPermitted) => {
        if (trimUrl(state.url) === RouteUrl.NotPermitted || isPermitted) {
          return true
        }
        void this._navCtrl.navigateForward([RouteUrl.NotPermitted])
        return false
      })
    )
  }
}
